(() => {
  if (window.CelticProductPage) {
    window.CelticProductPage.init(document);
    return;
  }

  const initGallery = (root) => {
    const main = root.querySelector('[data-celtic-main-image]');
    if (!main) return;
    const zoomButton = root.querySelector('[data-celtic-zoom-open]');
    const dialog = root.querySelector('[data-celtic-zoom-dialog]');
    const dialogImage = root.querySelector('[data-celtic-zoom-image]');

    root.querySelectorAll('[data-celtic-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        main.src = thumb.dataset.src || main.src;
        main.srcset = thumb.dataset.srcset || '';
        main.alt = thumb.dataset.alt || '';
        main.dataset.full = thumb.dataset.full || thumb.dataset.src || main.src;
        root.querySelectorAll('[data-celtic-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });

    if (zoomButton && dialog && dialogImage && typeof dialog.showModal === 'function') {
      zoomButton.addEventListener('click', () => {
        dialogImage.src = main.dataset.full || main.src;
        dialogImage.alt = main.alt || '';
        dialog.showModal();
      });
      dialog.querySelector('[data-celtic-zoom-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
  };

  const initQuantity = (root) => {
    const input = root.querySelector('[data-celtic-quantity]');
    if (!input) return;
    root.querySelector('[data-celtic-qty-minus]')?.addEventListener('click', () => {
      const min = Number(input.min || 1);
      input.value = Math.max(min, Number(input.value || min) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    root.querySelector('[data-celtic-qty-plus]')?.addEventListener('click', () => {
      const max = input.max ? Number(input.max) : Infinity;
      input.value = Math.min(max, Number(input.value || 1) + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const initVariant = (root) => {
    const select = root.querySelector('[data-celtic-variant-select]');
    if (!select) return;
    const idInput = root.querySelector('[data-celtic-variant-id]');
    const price = root.querySelector('[data-celtic-price]');
    const compare = root.querySelector('[data-celtic-compare-price]');
    const submit = root.querySelector('[data-celtic-submit]');

    const update = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      if (idInput) idInput.value = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.comparePrice || '';
        compare.hidden = !option.dataset.comparePrice;
      }
      if (submit) {
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? (submit.dataset.availableText || 'PREORDER NOW') : (submit.dataset.soldoutText || 'SOLD OUT');
      }
      if (option.dataset.mediaId) {
        root.querySelector(`[data-celtic-thumb][data-media-id="${option.dataset.mediaId}"]`)?.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    };
    select.addEventListener('change', update);
  };

  const initTabs = (root) => {
    const tablist = root.querySelector('[data-celtic-tablist]');
    if (!tablist) return;
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    const activate = (tab) => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach((panel) => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        tabs[nextIndex].focus();
        activate(tabs[nextIndex]);
      });
    });
  };

  const initRoot = (root) => {
    root.querySelectorAll('[data-celtic-product-root]').forEach((section) => {
      if (section.dataset.celticInitialized === 'true') return;
      section.dataset.celticInitialized = 'true';
      initGallery(section);
      initQuantity(section);
      initVariant(section);
    });
    root.querySelectorAll('[data-celtic-tabs-root]').forEach((section) => {
      if (section.dataset.celticTabsInitialized === 'true') return;
      section.dataset.celticTabsInitialized = 'true';
      initTabs(section);
    });
  };

  window.CelticProductPage = { init: initRoot };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRoot(document), { once: true });
  } else {
    initRoot(document);
  }
  document.addEventListener('shopify:section:load', (event) => initRoot(event.target));
})();
